import { useState } from "react";

interface Option {
    value: string;
    label: string;
}

interface CustomSelectProps {
    label: string;
    options: Option[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const CustomSelect = ({ label, options, value, onChange, placeholder = "Select..." }: CustomSelectProps) => {
    const [isOpen, setIsOpen] = useState(false);
    
    const handleSelect = (optionValue: string) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    const selectedOption = options.find((opt) => opt.value === value);
    
    return (
        <div className="relative w-full">
            {/* Select Button */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between px-4 py-3 text-left bg-[#0d1225] rounded-lg focus:outline-none focus:border-[#4DBDFF] pr-12"
            >
                <div className="flex items-center gap-3">
                    <span className="text-gray-400 text-sm font-medium">{label}:</span>
                    <span className="text-white text-lg font-medium">
                        {selectedOption ? selectedOption.label : placeholder}
                    </span>
                </div>
                <div className="absolute right-4 pointer-events-none">
                    <svg
                        className={`w-5 h-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                        style={{ color: '#4DBDFF' }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </button>

            {isOpen && (
                <div className="absolute z-50 w-full mt-1 bg-[#0d1225] rounded-lg shadow-lg max-h-60 overflow-auto">
                    {options.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => handleSelect(option.value)}
                            className="w-full px-4 py-3 text-left text-white hover:bg-[#3A3D42] focus:outline-none focus:bg-[#3A3D42] transition-colors"
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}

            {/* Click outside to close */}
            {isOpen && (
                <div 
                    className="fixed inset-0 z-40" 
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
};
